<template>
    <Layout title="Template toevoegen">

        <div class="max-w-7xl mx-auto py-8 px-4">
            <div class="bg-white shadow rounded-lg">
                <div class="px-6 py-4 border-b border-gray-200">
                    <h1 class="text-lg font-semibold text-gray-900">Template toevoegen</h1>
                </div>

                <div class="p-6">
                    <!-- Template Settings -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <!-- Naam -->
                        <div>
                            <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
                                Naam
                            </label>
                            <input
                                type="text"
                                id="name"
                                v-model="form.name"
                                class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                placeholder="Template naam"
                            />
                        </div>

                        <!-- Onderwerp -->
                        <div>
                            <label for="subject" class="block text-sm font-medium text-gray-700 mb-2">
                                Onderwerp
                            </label>
                            <input
                                type="text"
                                id="subject"
                                v-model="form.subject"
                                class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                placeholder="Email onderwerp"
                            />
                        </div>

                        <div>
                            <label for="from_email" class="block text-sm font-medium text-gray-700 mb-2">
                                Afzender Email
                            </label>
                            <div class="flex">
                                <input
                                    type="text"
                                    id="from_email"
                                    v-model="form.from_email"
                                    class="block w-full border-gray-300 rounded-l-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    placeholder="afzender"
                                />
                                <span class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                    @mailservice.abitsafer.today
                                </span>
                            </div>
                        </div>

                        <div>
                            <label for="from_name" class="block text-sm font-medium text-gray-700 mb-2">
                                Afzender Naam
                            </label>
                            <input
                                type="text"
                                id="from_name"
                                v-model="form.from_name"
                                class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                placeholder="Bedrijfsnaam"
                            />
                        </div>

                        <div>
                            <label for="difficulty" class="block text-sm font-medium text-gray-700 mb-2">
                                Moeilijkheid
                            </label>
                            <select
                                id="difficulty"
                                v-model="form.difficulty"
                                class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
                        </div>

                        <!-- Clues -->
                        <div>
                            <label for="clues" class="block text-sm font-medium text-gray-700 mb-2">
                                Clues (Markdown)
                            </label>
                            <textarea
                                id="clues"
                                rows="2"
                                v-model="form.clues"
                                class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                placeholder="Vul hier de aanwijzingen..."
                            ></textarea>
                        </div>
                    </div>

                    <!-- Custom Figma-like Email Editor -->
                    <div class="space-y-4">
                        <div class="flex justify-between items-center">
                            <h3 class="text-lg font-medium text-gray-900">Email Template Builder</h3>
                            <div class="flex items-center space-x-4">
                                <div class="text-sm text-gray-600">
                                    Sleep blokken naar het canvas om je email te maken
                                </div>
                                <button
                                    v-if="canvasBlocks.length > 0"
                                    @click="clearAll"
                                    class="px-3 py-1 bg-red-500 hover:bg-red-600 text-white text-sm rounded transition-colors"
                                >
                                    Alles wissen
                                </button>
                            </div>
                        </div>
                        


                        <div class="grid grid-cols-12 gap-6">
                            <!-- Toolbox -->
                            <div class="col-span-3 bg-gray-50 p-4 rounded-lg">
                                <h4 class="font-medium mb-4">Blokken</h4>
                                <div class="space-y-2">
                                    <div
                                        v-for="block in availableBlocks"
                                        :key="block.type"
                                        class="p-3 bg-white border border-gray-200 rounded cursor-move hover:shadow-md transition-shadow"
                                        draggable="true"
                                        @dragstart="onDragStart($event, block)"
                                    >
                                        <div class="flex items-center space-x-2">
                                            <span class="text-gray-600" v-html="block.icon"></span>
                                            <span class="text-sm font-medium">{{ block.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Canvas -->
                            <div class="col-span-9">
                                <div class="border-2 border-dashed border-gray-300 rounded-lg bg-gray-100 p-8 relative"
                                     :style="{
                                       minHeight: canvasBlocks.length === 0 ? '400px' : 'auto',
                                       maxHeight: '70vh',
                                       overflowY: canvasBlocks.length > 0 ? 'auto' : 'visible'
                                     }"
                                     @dragover="onDragOver"
                                     @drop="onDrop"
                                     @dragenter="onDragEnter"
                                     @dragleave="onDragLeave">
                                    <!-- Drop zone overlay -->
                                    <div v-if="canvasBlocks.length === 0" class="absolute inset-0 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50 bg-opacity-50 z-5">
                                        <div class="text-gray-500 text-center">
                                            <div class="text-4xl mb-2">📧</div>
                                            <p class="text-lg">Sleep blokken hiernaartoe</p>
                                        </div>
                                    </div>

                                    <!-- Email Preview Container -->
                                    <div v-if="canvasBlocks.length > 0" class="mx-auto bg-white shadow-lg" style="width: 550px; font-family: Arial, sans-serif;">
                                        <div class="relative" style="padding: 20px;">
                                            <template v-for="(block, index) in canvasBlocks">
                                                <!-- Drop zone above block -->
                                                <div
                                                    class="transition-all duration-200 relative"
                                                    :class="dragOverIndex === index ? 'h-16 mb-4' : 'h-12 mb-0'"
                                                    @dragover="onBlockDragOver($event, index)"
                                                    @dragleave="onBlockDragLeave"
                                                    @drop="onDrop($event, index)"
                                                >
                                                    <!-- Ghost indicator -->
                                                    <div 
                                                        v-if="dragOverIndex === index" 
                                                        class="absolute inset-0 bg-blue-100 border-2 border-dashed border-blue-400 rounded-lg flex items-center justify-center shadow-lg"
                                                    >
                                                        <span class="text-blue-600 text-lg font-semibold">📧 Drop blok hier</span>
                                                    </div>
                                                </div>
                                                
                                                <!-- Block with drag handle -->
                                                <div class="relative group" :class="{ 'opacity-50': draggedBlockIndex === index }">
                                                    <!-- Drag Handle -->
                                                    <div 
                                                        class="absolute -left-8 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity cursor-move z-20"
                                                        draggable="true"
                                                        @dragstart="onDragStart($event, block, index)"
                                                    >
                                                        <div class="bg-gray-400 hover:bg-gray-600 text-white p-1 rounded text-xs shadow-lg">☰</div>
                                                    </div>
                                                    
                                                    <!-- Dynamic Block Component -->
                                                    <div 
                                                        draggable="true"
                                                        @dragstart="onDragStart($event, block, index)"
                                                        class="cursor-move"
                                                    >
                                                        <component :is="getBlockComponent(block.type)" :data="block.data" @update="updateBlockData(index, $event)" />
                                                    </div>

                                                    <!-- Block Controls -->
                                                    <div class="absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                                                        <button @click.stop="editBlock(index)" class="bg-blue-500 text-white p-1 rounded text-xs shadow-lg">✏️</button>
                                                        <button @click.stop="deleteBlock(index)" class="bg-red-500 text-white p-1 rounded text-xs ml-1 shadow-lg">X</button>
                                                    </div>
                                                </div>
                                                
                                                <!-- Drop zone below last block -->
                                                <div 
                                                    v-if="index === canvasBlocks.length - 1"
                                                    :key="`drop-bottom-${index}`"
                                                    class="transition-all duration-200 mt-4 relative"
                                                    :class="dragOverIndex === canvasBlocks.length ? 'h-16' : 'h-12'"
                                                    @dragover="onBlockDragOver($event, canvasBlocks.length)"
                                                    @dragleave="onBlockDragLeave"
                                                    @drop="onDrop($event, canvasBlocks.length)"
                                                >
                                                    <!-- Ghost indicator for bottom drop -->
                                                    <div 
                                                        v-if="dragOverIndex === canvasBlocks.length" 
                                                        class="absolute inset-0 bg-blue-100 border-2 border-dashed border-blue-400 rounded-lg flex items-center justify-center shadow-lg"
                                                    >
                                                        <span class="text-blue-600 text-lg font-semibold">📧 Drop blok hier</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Block Editor Modal -->
                        <div v-if="editingBlock !== null" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div class="bg-white p-6 rounded-lg max-w-md w-full mx-4">
                                <h3 class="text-lg font-bold mb-4">Blok bewerken</h3>

                                <!-- Header Block Editor -->
                                <div v-if="editingBlockData.type === 'header'" class="space-y-4">
                                    <div><label class="block text-sm font-medium mb-1">Logo</label><div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center"><input type="file" accept="image/*" @change="handleModalImageUpload" class="hidden" id="create-header-logo-upload" /><label for="create-header-logo-upload" class="cursor-pointer"><div v-if="!editingBlockData.data.logo" class="text-gray-500"><div class="text-2xl mb-2">📁</div><p>Klik om logo te selecteren</p><p class="text-xs mt-1">Max 2MB, JPG/PNG</p></div><div v-else class="flex items-center justify-center"><img :src="editingBlockData.data.logo" class="max-h-20 rounded" /></div></label><button v-if="editingBlockData.data.logo" @click="editingBlockData.data.logo = null" class="mt-2 px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600">Verwijder logo</button></div></div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Titel</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('headerTitle')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    headerTitleEditor && headerTitleEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!headerTitleEditor"
                                            >
                                                <span v-if="headerTitleEditor && headerTitleEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ headerTitleEditor && headerTitleEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="headerTitleEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Ondertitel</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('headerSubtitle')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    headerSubtitleEditor && headerSubtitleEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!headerSubtitleEditor"
                                            >
                                                <span v-if="headerSubtitleEditor && headerSubtitleEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ headerSubtitleEditor && headerSubtitleEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="headerSubtitleEditor" />
                                        </div>
                                    </div>
                                    <div><label class="block text-sm font-medium mb-1">Tekstkleur</label><input type="color" v-model="editingBlockData.data.textColor" class="w-full border rounded px-3 py-2 h-10" /></div>
                                    <div><label class="block text-sm font-medium mb-1">Achtergrondkleur</label><input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" /></div>
                                    <div><label class="block text-sm font-medium mb-1">Border kleur</label><input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" /></div>
                                    <div><label class="block text-sm font-medium mb-1">Border dikte (px)</label><input type="number" min="0" max="10" v-model="editingBlockData.data.borderWidth" class="w-full border rounded px-3 py-2" placeholder="0" /></div>
                                </div>

                                <div v-if="editingBlockData.type === 'text'" class="space-y-4">
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Titel</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('textTitle')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    textTitleEditor && textTitleEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!textTitleEditor"
                                            >
                                                <span v-if="textTitleEditor && textTitleEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ textTitleEditor && textTitleEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="textTitleEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Titel kleur</label>
                                        <input type="color" v-model="editingBlockData.data.titleColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Tekst</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('text')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    textEditor && textEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!textEditor"
                                            >
                                                <span v-if="textEditor && textEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ textEditor && textEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[100px] bg-white">
                                            <editor-content :editor="textEditor" />
                                        </div>
                                        <div class="text-xs text-gray-500 mt-1">
                                            Selecteer tekst en klik op "Markeer" om met rode lijnen te markeren (zoals in Word)
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Tekstkleur</label>
                                        <input type="color" v-model="editingBlockData.data.textColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border kleur</label>
                                        <input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border dikte (px)</label>
                                        <input type="number" min="0" max="10" v-model="editingBlockData.data.borderWidth" class="w-full border rounded px-3 py-2" placeholder="1" />
                                    </div>
                                </div>

                                <!-- Image Block Editor -->
                                <div v-if="editingBlockData.type === 'image'" class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Afbeelding</label>
                                        <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
                                            <input type="file" accept="image/*" @change="handleModalImageUpload" class="hidden" id="editor-image-upload" />
                                            <label for="editor-image-upload" class="cursor-pointer">
                                                <div v-if="!editingBlockData.data.image" class="text-gray-500">
                                                    <div class="text-2xl mb-2">📁</div>
                                                    <p>Klik om afbeelding te selecteren</p>
                                                    <p class="text-xs mt-1">Max 2MB, JPG/PNG</p>
                                                </div>
                                                <div v-else class="flex items-center justify-center">
                                                    <img :src="editingBlockData.data.image" class="max-h-20 rounded" />
                                                </div>
                                            </label>
                                            <button v-if="editingBlockData.data.image" @click="editingBlockData.data.image = null" class="mt-2 px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600">Verwijder afbeelding</button>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Alt tekst</label>
                                        <input v-model="editingBlockData.data.alt" class="w-full border rounded px-3 py-2" placeholder="Beschrijving van de afbeelding" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border kleur</label>
                                        <input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border dikte (px)</label>
                                        <input type="number" min="0" max="10" v-model="editingBlockData.data.borderWidth" class="w-full border rounded px-3 py-2" placeholder="0" />
                                    </div>
                                </div>

                                <!-- Button Block Editor -->
                                <div v-if="editingBlockData.type === 'button'" class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Tekst</label>
                                        <input v-model="editingBlockData.data.text" class="w-full border rounded px-3 py-2" placeholder="Lees meer" />
                                    </div>
                                    <div class="text-sm text-gray-600">
                                        URL wordt automatisch ingesteld naar de clues pagina van dit template.
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Knop kleur</label>
                                        <input type="color" v-model="editingBlockData.data.buttonColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Tekst kleur</label>
                                        <input type="color" v-model="editingBlockData.data.textColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border kleur</label>
                                        <input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border dikte (px)</label>
                                        <input type="number" min="0" max="10" v-model="editingBlockData.data.borderWidth" class="w-full border rounded px-3 py-2" placeholder="0" />
                                    </div>
                                </div>

                                <!-- Spacer Block Editor -->
                                <div v-if="editingBlockData.type === 'spacer'" class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Hoogte (px)</label>
                                        <input type="number" v-model="editingBlockData.data.height" class="w-full border rounded px-3 py-2" placeholder="20" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Spacer kleur</label>
                                        <input type="color" v-model="editingBlockData.data.spacerColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border kleur</label>
                                        <input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border dikte (px)</label>
                                        <input type="number" min="0" max="10" v-model="editingBlockData.data.borderWidth" class="w-full border rounded px-3 py-2" placeholder="0" />
                                    </div>
                                </div>

                                <!-- Divider Block Editor -->
                                <div v-if="editingBlockData.type === 'divider'" class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Dikte (px)</label>
                                        <input type="number" min="1" max="10" v-model="editingBlockData.data.thickness" class="w-full border rounded px-3 py-2" placeholder="2" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Kleur</label>
                                        <input type="color" v-model="editingBlockData.data.color" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Stijl</label>
                                        <select v-model="editingBlockData.data.style" class="w-full border rounded px-3 py-2">
                                            <option value="solid">Doorgetrokken</option>
                                            <option value="dashed">Gestreept</option>
                                            <option value="dotted">Gestippeld</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Breedte</label>
                                        <select v-model="editingBlockData.data.width" class="w-full border rounded px-3 py-2">
                                            <option value="100%">Volledige breedte</option>
                                            <option value="80%">80%</option>
                                            <option value="60%">60%</option>
                                            <option value="40%">40%</option>
                                        </select>
                                    </div>
                                </div>

                                <div v-if="editingBlockData.type === 'alert'" class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Type</label>
                                        <select v-model="editingBlockData.data.type" @change="updateAlertTypeInModal" class="w-full border rounded px-3 py-2">
                                            <option value="info">Info</option>
                                            <option value="warning">Waarschuwing</option>
                                            <option value="success">Succes</option>
                                            <option value="error">Fout</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Titel</label>
                                        <input v-model="editingBlockData.data.title" class="w-full border rounded px-3 py-2" placeholder="Belangrijk" />
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Inhoud</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('alert')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    alertEditor && alertEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!alertEditor"
                                            >
                                                <span v-if="alertEditor && alertEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ alertEditor && alertEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[80px] bg-white">
                                            <editor-content :editor="alertEditor" />
                                        </div>
                                        <div class="text-xs text-gray-500 mt-1">
                                            Selecteer tekst en klik op "Markeer" om met rode lijnen te markeren (zoals in Word)
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Icon</label>
                                        <input v-model="editingBlockData.data.icon" class="w-full border rounded px-3 py-2" placeholder="ℹ️" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Border kleur</label>
                                        <input type="color" v-model="editingBlockData.data.borderColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Tekstkleur</label>
                                        <input type="color" v-model="editingBlockData.data.textColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                </div>

                                <div v-if="editingBlockData.type === 'footer'" class="space-y-4">
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Bedrijfsnaam</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('footerCompanyName')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    footerCompanyNameEditor && footerCompanyNameEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!footerCompanyNameEditor"
                                            >
                                                <span v-if="footerCompanyNameEditor && footerCompanyNameEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ footerCompanyNameEditor && footerCompanyNameEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="footerCompanyNameEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Adres</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('footerAddress')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    footerAddressEditor && footerAddressEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!footerAddressEditor"
                                            >
                                                <span v-if="footerAddressEditor && footerAddressEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ footerAddressEditor && footerAddressEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="footerAddressEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Telefoon</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('footerPhone')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    footerPhoneEditor && footerPhoneEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!footerPhoneEditor"
                                            >
                                                <span v-if="footerPhoneEditor && footerPhoneEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ footerPhoneEditor && footerPhoneEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="footerPhoneEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="flex items-center justify-between mb-1">
                                            <label class="block text-sm font-medium">Email</label>
                                            <button 
                                                type="button" 
                                                @click="toggleRedMark('footerEmail')" 
                                                :class="[
                                                    'text-xs px-3 py-1.5 rounded font-medium transition-all flex items-center gap-1.5',
                                                    footerEmailEditor && footerEmailEditor.isActive('redMark')
                                                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                                                        : 'bg-red-500 text-white hover:bg-red-600'
                                                ]"
                                                :disabled="!footerEmailEditor"
                                            >
                                                <span v-if="footerEmailEditor && footerEmailEditor.isActive('redMark')">✓</span>
                                                <span v-else>🔴</span>
                                                <span>{{ footerEmailEditor && footerEmailEditor.isActive('redMark') ? 'Ontmarkeer' : 'Markeer' }}</span>
                                            </button>
                                        </div>
                                        <div class="border rounded p-2 min-h-[60px] bg-white">
                                            <editor-content :editor="footerEmailEditor" />
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Achtergrondkleur</label>
                                        <input type="color" v-model="editingBlockData.data.backgroundColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium mb-1">Tekstkleur</label>
                                        <input type="color" v-model="editingBlockData.data.textColor" class="w-full border rounded px-3 py-2 h-10" />
                                    </div>
                                    <div>
                                        <label class="flex items-center">
                                            <input type="checkbox" v-model="editingBlockData.data.showSocial" class="mr-2" />
                                            <span class="text-sm font-medium">Toon social media links (verwijzen naar clues)</span>
                                        </label>
                                    </div>
                                    <div v-if="editingBlockData.data.showSocial">
                                        <label class="block text-sm font-medium mb-2">Selecteer social media icons (max 5)</label>
                                        <div class="grid grid-cols-2 gap-2">
                                            <label v-for="(icon, key) in getSocialIcons()" :key="key" class="flex items-center">
                                                <input 
                                                    type="checkbox" 
                                                    :value="key" 
                                                    v-model="editingBlockData.data.socialIcons" 
                                                    :disabled="!editingBlockData.data.socialIcons.includes(key) && editingBlockData.data.socialIcons.length >= 5"
                                                    class="mr-2" 
                                                />
                                                <svg class="w-4 h-4 mr-1" :fill="icon.color" viewBox="0 0 24 24" v-html="icon.svg"></svg>
                                                <span class="text-sm">{{ icon.name }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex justify-end space-x-2 mt-6">
                                    <button @click="cancelEdit" class="px-4 py-2 bg-gray-500 text-white rounded">Annuleren</button>
                                    <button @click="saveBlockEdit" class="px-4 py-2 bg-blue-500 text-white rounded">Opslaan</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-end mt-6">
                        <button
                            @click="save"
                            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        >
                            Template opslaan
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
import Layout from '../../Shared/Layout';
import { getAvailableBlocks, getDefaultBlockData, generateBlockHTML } from '../../EmailBlokken';
import HeaderBlock from '../../EmailBlokken/HeaderBlock.vue';
import TextBlock from '../../EmailBlokken/TextBlock.vue';
import ButtonBlock from '../../EmailBlokken/ButtonBlock.vue';
import ImageBlock from '../../EmailBlokken/ImageBlock.vue';
import SpacerBlock from '../../EmailBlokken/SpacerBlock.vue';
import DividerBlock from '../../EmailBlokken/DividerBlock.vue';
import AlertBlock, { ALERT_TYPES } from '../../EmailBlokken/AlertBlock.vue';
import FooterBlock from '../../EmailBlokken/FooterBlock.vue';
import { EditorContent } from '@tiptap/vue-2';
import { 
    convertHTMLToRedTags, 
    createRedMarkEditor,
    destroyAllEditors
} from '../../EmailBlokken/redMarkHelpers';

export default {
    name: 'Create',
    components: {
        Layout,
        HeaderBlock,
        TextBlock,
        ButtonBlock,
        ImageBlock,
        SpacerBlock,
        DividerBlock,
        AlertBlock,
        FooterBlock,
        EditorContent,
    },

    props: {
        auth: Object,
        flash: Object,
    },

    data() {
        return {
            canvasBlocks: [],
            availableBlocks: getAvailableBlocks(),
            editingBlock: null,
            editingBlockData: null,
            isDraggingOver: false,
            dragOverIndex: -1,
            draggedBlockIndex: -1,
            textEditor: null,
            alertEditor: null,
            headerTitleEditor: null,
            headerSubtitleEditor: null,
            textTitleEditor: null,
            footerCompanyNameEditor: null,
            footerAddressEditor: null,
            footerPhoneEditor: null,
            footerEmailEditor: null,
            form: {
                name: '',
                subject: '',
                from_email: '',
                from_name: '',
                difficulty: '3',
                clues: '',
                content: '',
                blocks: ''
            }
        }
    },

    methods: {
        onDragStart(event, block, fromIndex = null) {
            event.stopPropagation();
            const dragData = { block, fromIndex };
            event.dataTransfer.setData('application/json', JSON.stringify(dragData));
            event.dataTransfer.effectAllowed = fromIndex !== null ? 'move' : 'copy';
            if (fromIndex !== null) {
                this.draggedBlockIndex = fromIndex;
            }
        },

        onDrop(event, dropIndex = null) {
            event.preventDefault();
            event.stopPropagation();
            this.isDraggingOver = false;
            this.dragOverIndex = -1;
            this.draggedBlockIndex = -1;
            try {
                const dragData = JSON.parse(event.dataTransfer.getData('application/json'));
                if (dragData.fromIndex !== null) {
                    this.moveBlock(dragData.fromIndex, dropIndex);
                } else {
                    this.addBlockToCanvas(dragData.block, dropIndex);
                }
            } catch (error) {
                console.error('Error parsing dropped block:', error);
            }
        },

        onDragEnter(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
            this.isDraggingOver = true;
        },

        onDragLeave(event) {
            event.preventDefault();
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;

            if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
                this.isDraggingOver = false;
            }
        },

        onDragOver(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
        },

        addBlockToCanvas(blockType, insertIndex = null) {
            const newBlock = {
                type: blockType.type,
                data: getDefaultBlockData(blockType.type)
            };
            if (insertIndex !== null) {
                this.canvasBlocks.splice(insertIndex, 0, newBlock);
            } else {
                this.canvasBlocks.push(newBlock);
            }
        },

        moveBlock(fromIndex, toIndex) {
            if (fromIndex === toIndex) {
                this.draggedBlockIndex = -1;
                return;
            }
            
            const block = this.canvasBlocks.splice(fromIndex, 1)[0];
            
            let insertIndex = toIndex !== null ? toIndex : this.canvasBlocks.length;
            if (toIndex !== null && fromIndex < toIndex) {
                insertIndex = toIndex - 1;
            }
            
            this.canvasBlocks.splice(insertIndex, 0, block);
        },

        onBlockDragOver(event, index) {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = event.dataTransfer.effectAllowed === 'move' ? 'move' : 'copy';
            this.dragOverIndex = index;
        },

        onBlockDragLeave(event) {
            event.stopPropagation();
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;
            
            if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
                this.dragOverIndex = -1;
            }
        },

        selectBlock(index) {
        },

        editBlock(index) {
            this.editingBlock = index;
            this.editingBlockData = JSON.parse(JSON.stringify(this.canvasBlocks[index]));
            if (this.editingBlockData.type === 'footer' && !this.editingBlockData.data.socialIcons) {
                this.editingBlockData.data.socialIcons = ['facebook', 'twitter', 'instagram'];
            }
            
            this.$nextTick(() => {
                const initMethods = {
                    header: ['initHeaderTitleEditor', 'initHeaderSubtitleEditor'],
                    text: ['initTextEditor', 'initTextTitleEditor'],
                    alert: ['initAlertEditor'],
                    footer: ['initFooterCompanyNameEditor', 'initFooterAddressEditor', 'initFooterPhoneEditor', 'initFooterEmailEditor']
                };
                
                const methods = initMethods[this.editingBlockData.type] || [];
                methods.forEach(method => {
                    if (this[method]) {
                        this[method]();
                    }
                });
            });
        },

        deleteBlock(index) {
            this.canvasBlocks.splice(index, 1);
        },

        saveBlockEdit() {
            if (this.editingBlock !== null) {
                const editorMappings = {
                    header: [
                        { editor: 'headerTitleEditor', field: 'title' },
                        { editor: 'headerSubtitleEditor', field: 'subtitle' }
                    ],
                    text: [
                        { editor: 'textEditor', field: 'content' },
                        { editor: 'textTitleEditor', field: 'title' }
                    ],
                    alert: [
                        { editor: 'alertEditor', field: 'content' }
                    ],
                    footer: [
                        { editor: 'footerCompanyNameEditor', field: 'companyName' },
                        { editor: 'footerAddressEditor', field: 'address' },
                        { editor: 'footerPhoneEditor', field: 'phone' },
                        { editor: 'footerEmailEditor', field: 'email' }
                    ]
                };
                
                const mappings = editorMappings[this.editingBlockData.type] || [];
                mappings.forEach(({ editor, field }) => {
                    if (this[editor]) {
                        const html = this[editor].getHTML();
                        this.editingBlockData.data[field] = convertHTMLToRedTags(html);
                    }
                });
                
                this.canvasBlocks[this.editingBlock] = this.editingBlockData;
                this.cancelEdit();
            }
        },

        cancelEdit() {
            destroyAllEditors(this);
            this.editingBlock = null;
            this.editingBlockData = null;
        },
        initEditorForField(editorVar, content, updateCallback) {
            if (this[editorVar]) {
                this[editorVar].destroy();
            }
            this[editorVar] = createRedMarkEditor(content || '', updateCallback);
        },
        initTextEditor() {
            if (this.textEditor) {
                this.textEditor.destroy();
            }
            this.textEditor = createRedMarkEditor(
                this.editingBlockData.data.content || '',
                (content) => { this.editingBlockData.data.content = content; }
            );
        },
        initAlertEditor() {
            if (this.alertEditor) {
                this.alertEditor.destroy();
            }
            this.alertEditor = createRedMarkEditor(
                this.editingBlockData.data.content || '',
                (content) => { this.editingBlockData.data.content = content; }
            );
        },
        initHeaderTitleEditor() {
            this.initEditorForField('headerTitleEditor', this.editingBlockData.data.title, (content) => {
                this.editingBlockData.data.title = content;
            });
        },
        initHeaderSubtitleEditor() {
            this.initEditorForField('headerSubtitleEditor', this.editingBlockData.data.subtitle, (content) => {
                this.editingBlockData.data.subtitle = content;
            });
        },
        initTextTitleEditor() {
            this.initEditorForField('textTitleEditor', this.editingBlockData.data.title, (content) => {
                this.editingBlockData.data.title = content;
            });
        },
        initFooterCompanyNameEditor() {
            this.initEditorForField('footerCompanyNameEditor', this.editingBlockData.data.companyName, (content) => {
                this.editingBlockData.data.companyName = content;
            });
        },
        initFooterAddressEditor() {
            this.initEditorForField('footerAddressEditor', this.editingBlockData.data.address, (content) => {
                this.editingBlockData.data.address = content;
            });
        },
        initFooterPhoneEditor() {
            this.initEditorForField('footerPhoneEditor', this.editingBlockData.data.phone, (content) => {
                this.editingBlockData.data.phone = content;
            });
        },
        initFooterEmailEditor() {
            this.initEditorForField('footerEmailEditor', this.editingBlockData.data.email, (content) => {
                this.editingBlockData.data.email = content;
            });
        },
        toggleRedMark(type) {
            const editorMap = {
                text: 'textEditor',
                alert: 'alertEditor',
                headerTitle: 'headerTitleEditor',
                headerSubtitle: 'headerSubtitleEditor',
                textTitle: 'textTitleEditor',
                footerCompanyName: 'footerCompanyNameEditor',
                footerAddress: 'footerAddressEditor',
                footerPhone: 'footerPhoneEditor',
                footerEmail: 'footerEmailEditor'
            };
            
            const editor = this[editorMap[type]];
            if (!editor) return;
            editor.chain().focus().toggleRedMark().run();
        },

        updateBlockData(index, newData) {
            console.log('Updating block data:', index, newData);
            this.$set(this.canvasBlocks, index, { ...this.canvasBlocks[index], data: newData });
        },

        clearAll() {
            if (confirm('Weet je zeker dat je alle blokken wilt verwijderen?')) {
                this.canvasBlocks = [];
            }
        },



        getBlockComponent(type) {
            // Direct component mapping
            const componentMap = {
                header: 'HeaderBlock',
                text: 'TextBlock',
                button: 'ButtonBlock',
                image: 'ImageBlock',
                spacer: 'SpacerBlock',
                divider: 'DividerBlock',
                alert: 'AlertBlock',
                footer: 'FooterBlock'
            };
            return componentMap[type] || null;
        },

        generateEmailHTML() {
            let html = `
<table width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 550px; margin: 0 auto; font-family: Arial, sans-serif; background-color: #ffffff;">
    <tr>
        <td style="padding: 20px;">
`;

            this.canvasBlocks.forEach(block => {
                html += generateBlockHTML(block.type, block.data);
            });

            html += `
        </td>
    </tr>
</table>`;
            return html;
        },





        updateAlertTypeInModal() {
            const typeData = ALERT_TYPES[this.editingBlockData.data.type];
            if (typeData) Object.assign(this.editingBlockData.data, typeData);
        },
        getSocialIcons() {
            return {
                facebook: { name: 'Facebook', color: '#1877F2', svg: '<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>' },
                twitter: { name: 'Twitter', color: '#1DA1F2', svg: '<path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>' },
                instagram: { name: 'Instagram', color: '#E4405F', svg: '<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>' },
                linkedin: { name: 'LinkedIn', color: '#0A66C2', svg: '<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>' },
                youtube: { name: 'YouTube', color: '#FF0000', svg: '<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>' },
                tiktok: { name: 'TikTok', color: '#000000', svg: '<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>' },
                whatsapp: { name: 'WhatsApp', color: '#25D366', svg: '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>' },
                email: { name: 'Email', color: '#6B7280', svg: '<path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>' }
            };
        },

        handleModalImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                if (file.size > 2 * 1024 * 1024) {
                    alert('Afbeelding is te groot. Maximum grootte is 2MB.');
                    return;
                }
                const formData = new FormData();
                formData.append('image', file);
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                fetch('/templates/upload-image', {
                    method: 'POST',
                    body: formData,
                    headers: { 'X-CSRF-TOKEN': csrfToken }
                })
                .then(async response => {
                    if (!response.ok) {
                        const errorText = await response.text();
                        try {
                            const errorJson = JSON.parse(errorText);
                            throw new Error(errorJson.message || errorJson.error || `HTTP ${response.status}`);
                        } catch {
                            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                        }
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.imageUrl) {
                        // Check if this is a header logo upload or regular image upload
                        if (event.target.id === 'create-header-logo-upload') {
                            this.$set(this.editingBlockData.data, 'logo', data.imageUrl);
                        } else {
                            this.$set(this.editingBlockData.data, 'image', data.imageUrl);
                            this.$set(this.editingBlockData.data, 'imagePath', data.imagePath);
                        }
                    } else {
                        throw new Error('No image URL in response');
                    }
                })
                .catch(error => {
                    console.error('Upload error:', error);
                    alert('Fout bij uploaden van afbeelding: ' + error.message);
                });
            }
            event.target.value = '';
        },

        save() {
            if (!this.form.name.trim()) {
                alert('Vul een naam in voor het template.');
                return;
            }

            if (!this.form.subject.trim()) {
                alert('Vul een onderwerp in voor het template.');
                return;
            }

            if (!this.form.from_email.trim()) {
                alert('Vul een afzender email in voor het template.');
                return;
            }

            if (!this.form.from_name.trim()) {
                alert('Vul een afzender naam in voor het template.');
                return;
            }

            if (!this.form.difficulty) {
                alert('Selecteer een moeilijkheidsgraad.');
                return;
            }

            if (!this.form.clues.trim()) {
                alert('Vul aanwijzingen in voor het template.');
                return;
            }

            if (this.canvasBlocks.length === 0) {
                alert('Voeg eerst blokken toe aan je email template.');
                return;
            }

            this.form.content = this.generateEmailHTML();

            this.form.blocks = JSON.stringify(this.canvasBlocks);

            this.$inertia.post('/templates', this.form, {
                onSuccess: () => {
                    this.form = {
                        name: '',
                        subject: '',
                        from_email: '',
                        from_name: '',
                        difficulty: '3',
                        clues: '',
                        content: '',
                        blocks: ''
                    };
                    this.canvasBlocks = [];
                }
            });
        }
    },
    beforeDestroy() {
        destroyAllEditors(this);
    }
}
</script>